export const DOCUMENT_TYPE_CC = 'CC'
export const DOCUMENT_TYPE_TI = 'TI'
